import { injectable, inject } from 'inversify';
import { SuspendDataStore, SuspendDataStoreSymbol, SuspendDataStateStore } from '@/app/tracking/common';
import { interactionStateReducer, InteractionCommand } from './interaction-state-reducer2';
import { InteractionTrackingState, defaultInteractionTrackingState } from './interaction-state2'

interface InteractionsSuspendData {
  interactions: InteractionTrackingState[];
}

@injectable()
export class InteractionSuspendDataStore2 {

  private store: SuspendDataStateStore<InteractionTrackingState, unknown, InteractionCommand>;

  constructor(
    @inject(SuspendDataStoreSymbol)
    suspendDataStore: SuspendDataStore<InteractionsSuspendData>) {

    this.store = new SuspendDataStateStore(
      () => suspendDataStore.get2('interactions'),
      (data: InteractionTrackingState[]) => suspendDataStore.update2('interactions', data),
      (id) => defaultInteractionTrackingState(id),
      interactionStateReducer);
  }

  public async query(ids: string[] | 'all') {
    return this.store.query(ids);
  }

  public async execute(command: InteractionCommand) {
    await this.store.execute(command);
  }
}
